import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FirstPageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"first_page"}/>
}
